export default __webpack_public_path__ + "static/media/usdc-private.d346a437.png";